import React from 'react';

export const RemoteConfigContext = React.createContext({});
